import axios from 'axios'
import gaEvent from 'utilities/tracking'
import { API_LANDLINE_URL } from 'containers/Checkout/constants'
import { setError, isLoading } from 'containers/Checkout/actions'
import { flattenErrors } from 'utilities/formValidator.util'
import { OWNS_SERVICE_KEY, GA_EVENT_CATEGORY } from './constants'

export const OWNER_FIELD_ERRORS = 'OWNER_FIELD_ERRORS'
export const OWNER_SUBMIT_SUCCESS = 'OWNER_SUBMIT_SUCCESS'
export const OWNER_CLEAR_FIELD_ERROR = 'OWNER_CLEAR_FIELD_ERROR'

function submitSuccess(nextStage, isOwner) {
  return {
    type: OWNER_SUBMIT_SUCCESS,
    payload: {
      nextStage,
      isOwner,
    },
  }
}

export function setFieldErrors(errors) {
  Object.keys(errors).forEach((field) => {
    gaEvent('Invalid', {
      event_category: GA_EVENT_CATEGORY,
      event_label: field,
      field_name: field,
      error_message: errors[field],
      non_interaction: true,
    })
  })
  return {
    type: OWNER_FIELD_ERRORS,
    payload: errors,
  }
}

export function clearFieldError(fieldName) {
  return {
    type: OWNER_CLEAR_FIELD_ERROR,
    payload: fieldName,
  }
}

export function submitForm(data) {
  return (dispatch) => {
    dispatch(isLoading(true))
    axios
      .post(API_LANDLINE_URL, data)
      .then((response) => {
        if (response.data.success) {
          dispatch(submitSuccess(response.data.next, data[OWNS_SERVICE_KEY]))
          gaEvent('Success', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Owner Details Submitted',
          })
        } else {
          dispatch(setError(true))
        }
      })
      .catch((error) => {
        if (error.response.data && error.response.data.errors) {
          dispatch(setFieldErrors(flattenErrors(error.response.data.errors)))
        } else {
          dispatch(setError(true))
          gaEvent('Error', {
            event_category: GA_EVENT_CATEGORY,
            event_label: 'Network Error',
          })
        }
      })
  }
}



// WEBPACK FOOTER //
// ./containers/stages/OwnerCheckStage/actions.js